import useAuth from '../../../../hooks/useAuth'
import React, {useEffect, useState, FC} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {i18n} from '../../../../translate/i18n'
import {Loading} from '../../../../components/Loading/Loading'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'
import {Input} from '../../../../components/Input/Input'
 
import {GET, POST} from '../../../../services/api'
import {Button} from '../../../../components/Button/Button'
import ReactLoading from 'react-loading'
import styles from './newCreate.module.css'
import {IndexGrade} from '../../../../components/Modals/Variacoes/Grade/indexGrade'
import {EditVariacao} from '../../../../components/Modals/Variacoes/Variacao/editVariacao'
import uuid from 'react-uuid'
import { EditorQuill } from '../../../../components/EditorQuill/EditorQuill'

type ReturnType = {
  id: string
  parent: string
  code: string
  name: string
  description: string
  value: string
  select: string
  shortname: string
  order: string
}

type PluginconfigType = {
  id: number
  name: string
  content: any
  plugintemplateId: number
  plugintypeId: number
}

type TemplateType = {
  id: number
  name: string
  image: string | null
  parameters: string
  plugintypeId: number
  pluginconfig: PluginconfigType
  typeIntegration: string
  able: boolean | null
}

type GridTypeResponse = {
  id: number
  name: string
  variation: string
  status?: boolean
  variationId?: number
}

const NewCriarProdutosContent: FC = () => {
  const {loginInfo} = useAuth()
  const [loading, setLoading] = useState(false)
  const [canAlert, setCanAlert] = useState(false)
  const [pluginIA, setPluginIA] = useState('')
  const [loadingDescIA, setLoadingDescIA] = useState(false)

  const [name, setName] = useState<string>('')
  const [description, setDescription] = useState<string>('')
  const [technicalSpecification, setTechnicalSpecification] = useState<string>('')
  const [subcategoryId, setSubcategoryId] = useState<string>('0')
  const [markId, setMarkId] = useState<string>('0')
  const [measurementId, setMeasurementId] = useState<string>('')
  const [status, setStatus] = useState<boolean>(true)
  const [order, setOrder] = useState<string>('')
  const [filesMedidas, setFilesMedidas] = useState<File[]>([])
  const [filesProduto, setFilesProduto] = useState<File[]>([])
  const [weight, setWeight] = useState<number>()
  const [height, setHeight] = useState<number>()
  const [width, setWidth] = useState<number>()
  const [deep, setDeep] = useState<number>()

  const [grids, setGrids] = useState<GridTypeResponse[]>([])
  const [gradeSelected, setGradeSelected] = useState<{variationId: number; variations: string[]}[]>(
    []
  )

  const [isSimpleProduct, setIsSimpleProduct] = useState<boolean>(true)
  const [isVariationProduct, setIsVariationProduct] = useState<boolean>(false)
  const [categories, setCategories] = useState<any[]>([])
  const [listClassification, setListClassification] = useState<any[]>([])
  const [marks, setMarks] = useState<any[]>([])
  const [measurements, setMeasurements] = useState<any[]>([])
  const [price, setPrice] = useState<number>()
  const [promotionalPrice, setPromotionalPrice] = useState<number>()
  const [costPrice, setCostPrice] = useState<number>()
  const [stockType, setStockType] = useState<string>('infinite')
  const [stockQuantity, setStockQuantity] = useState<number>()

  const [showVariacoesModal, setShowVariacoesModal] = useState(false)
  const [showEditVariacao, setShowEditVariacao] = useState(false)
  const [variacaoSelecionada, setVariacaoSelecionada] = useState<any>(null)

  const [variacoesTabela, setVariacoesTabela] = useState<any[]>([])

  const generateClassificationTree = (
    categories: ReturnType[],
    parent: string | null,
    name: string,
    code: string
  ): any => {
    const parentCategory = categories.find((category) => category.code === parent)
    if (parentCategory)
      return `${generateClassificationTree(
        categories,
        parentCategory.parent,
        parentCategory.name,
        parentCategory.code
      )} > [${code}] ${name}`
    else return `[${code}] ${name}`
  }

  const getCategories = async () => {
    try {
      const res = await GET(`/classification`)
      // Categorias por order
      // Validar, está incorreot
      const sortedCategories = res.data.sort((a: ReturnType, b: ReturnType) => {
        const orderA = parseInt(a.order || '0')
        const orderB = parseInt(b.order || '0')
        return orderA - orderB
      })

      sortedCategories.map((row: ReturnType) => {
        listClassification.push({
          id: row.id,
          parent: row.parent,
          code: row.code,
          name: generateClassificationTree(sortedCategories, row.parent, row.name, row.code),
        })
      })

      const categories = [
        {
          value: '0',
          select: 'Selecione',
          key: -1,
        },
      ]
      listClassification.map((row: any, idx) => {
        categories.push({
          value: row.id,
          select: row.name,
          key: idx,
        })
      })
      setCategories(categories)
    } catch (e) {
      console.log(e)
    }
  }

  const getMarks = async () => {
    try {
      const res = await GET('/mark')
      const marks = [
        {
          value: '0',
          select: 'Selecione',
        },
      ]
      res.data
        .sort((a: ReturnType, b: ReturnType) => a.name.localeCompare(b.name))
        .map((row: ReturnType) => {
          marks.push({
            value: row.id,
            select: row.name,
          })
        })
      setMarks(marks)
    } catch (e) {
      console.log(e)
    }
  }

  const getMeasurements = async () => {
    try {
      const res = await GET('/measurement')
      const measurements = [
        {
          value: '0',
          select: 'Selecione',
        },
      ]
      res.data
        .sort((a: ReturnType, b: ReturnType) => a.shortname.localeCompare(b.shortname))
        .map((row: ReturnType) => {
          measurements.push({
            value: row.id,
            select: row.description,
          })
        })
      setMeasurements(measurements)
    } catch (e) {
      console.log(e)
    }
  }

  const verifyIA = async () => {
    const templateRes = await GET('/plugintemplate/ia')
    if (templateRes && templateRes.data) {
      templateRes.data.forEach((template: TemplateType) => {
        if (template.pluginconfig) {
          if (
            template.pluginconfig.content &&
            template.pluginconfig.content.able &&
            template.pluginconfig.content.able !== '0'
          ) {
            setPluginIA(template.pluginconfig.content.modelId)
          }
        }
      })
    }
  }

  const generateDescriptionIA = async () => {
    setLoadingDescIA(true)
    try {
      if (pluginIA) {
        const result = await POST('structure-correction-ia/converse-structure', {
          prompt:
            description === ''
              ? `Crie a descrição do produto com base no nome que estou passando. Segue o nome: ${name}`
              : `Corrija ou melhore a descrição do produto que estou passando. Segue a descrição: ${description}`,
          modelId: pluginIA,
          systemPrompt: description === '' ? 'Criar o texto' : 'Revisar o texto',
          typeCorrectionStructure:
            description === '' ? 'description-structure' : 'revision-structure',
        })
        if (result && result.message && result.message.data) {
          setDescription(result.message.data)
          setCanAlert(true)
        }
      }
    } catch (e) {
      console.log('Erro ao chamar API IA (Descrição):', e)
    } finally {
      setLoadingDescIA(false)
    }
  }

  const getGrids = async () => {
    try {
      const gridRes = await GET('/grid')
      const newGrids: GridTypeResponse[] = []
      gridRes.data.map((grid: GridTypeResponse) => {
        grid.status &&
          newGrids.push({
            id: grid.id,
            name: grid.name,
            variation: grid.variation,
          })
      })
      setGrids(newGrids)
    } catch (e) {
      console.log(e)
    }
  }

  const findNameGrade = (itemSelected: any) => {
    return grids.find((grade) => grade.id === itemSelected.variationId)?.name
  }

  const init = async () => {
    setLoading(true)
    await verifyIA()
    await getCategories()
    await getMarks()
    await getMeasurements()
    await getGrids()
    setLoading(false)
  }

  useEffect(() => {
    init()
  }, [])

  const handleRemoveVariation = (variationId: number, variationSelected: string) => {
    setGradeSelected((prev) =>
      prev
        .map((grade) =>
          grade.variationId === variationId
            ? {
                ...grade,
                variations: grade.variations.filter((v) => v !== variationSelected),
              }
            : grade
        )
        .filter((grade) => grade.variations.length > 0)
    )
  }

  // Função para criar as combinações de variações
  function createVariations(arrays: string[][]): string[][] {
    return arrays.reduce(
      (a, b) => a.map((x) => b.map((y) => x.concat([y]))).reduce((a, b) => a.concat(b), []),
      [[]] as string[][]
    )
  }

  useEffect(() => {
    if (gradeSelected.length > 0) {
      const variationsArrays = gradeSelected.map((grade) => grade.variations)
      const combinations = createVariations(variationsArrays)
      const nomesGrades = gradeSelected.map((grade) => findNameGrade(grade))
      const novasVariacoes = combinations.map((comb, idx) => ({
        id: uuid(),
        combination: comb,
        nome: comb.join(' '),
        estoque: stockType === 'infinite' ? '∞' : stockQuantity ? stockQuantity : '0',
        precoVenda: price
          ? `${price.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}`
          : 'R$ 0,00',
        precoCusto: costPrice
          ? `${costPrice.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}`
          : 'R$ 0,00',
        precoPromocional: promotionalPrice
          ? `${promotionalPrice.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}`
          : 'R$ 0,00',
        height: height ? height : 0,
        width: width ? width : 0,
        deep: deep ? deep : 0,
        weight: weight ? weight : 0,
        minumunStock: '',
        productAvailability: '',
        productOutOfStock: '',
        modality: 'whithdrawal',
        sku: '',
        referenceCode: '',
        gtin: '',
        mpn: '',
        ncm: '',
        status: true,
        img: 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/icons/card-image.svg',
      }))
      setVariacoesTabela(novasVariacoes)
    } else {
      setVariacoesTabela([])
    }
  }, [gradeSelected])

  const handleSaveVariacao = (variacaoEditada: any) => {
    setVariacoesTabela((prev) =>
      prev.map((v) => (v.id === variacaoEditada.id ? variacaoEditada : v))
    )
  }

  useEffect(() => {
    if (showEditVariacao || showVariacoesModal) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [showEditVariacao, showVariacoesModal])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className='row g-5 gx-xxl-12 pb-5'>
            <div className='d-flex justify-content-between flex-wrap w-100 gap-5'>
              <div className='me-5' style={{flex: 1}}>
                <div className='card'>
                  <div className='card-header py-5'>
                    <h3 className='card-title align-items-start flex-column'>
                      <span className='card-label fw-bold fs-4 mb-1'>
                        {i18n.t(`smart_order.create_product`)}
                      </span>
                      <BreadCrumbs />
                    </h3>
                  </div>
                </div>
                <div className='card mt-8'>
                  <div className='px-10 py-5'>
                    <h1 className={styles.sectionTitle}>
                      <i className='bi bi-file-earmark-text'></i>
                      Detalhes do Produto
                    </h1>
                    <div className='mt-8'>
                      {/* Informações do Produto */}
                      <div className={`${styles.groupTitle} mt-1`}>Informações do Produto</div>

                      <Input
                        inputAttr={{
                          type: 'default',
                        }}
                        placeholder={i18n.t(`smart_order.name`)}
                        label={i18n.t(`smart_order.name`)}
                        value={name}
                        change={(value: string) => {
                          setCanAlert(true)
                          setName(value)
                        }}
                        generateValueIA={
                          pluginIA && pluginIA !== ''
                            ? {
                                modelId: pluginIA,
                                prompt:
                                  name === ''
                                    ? 'Sugira um nome de produto com base na descrição: ' +
                                      description
                                    : 'Corrija o nome do produto: ' + name,
                                action: name === '' ? 'create' : 'fix',
                              }
                            : undefined
                        }
                      />
                      <div className='mt-6'>
                        <div className={styles.descriptionHeader}>
                          <label className='form-label fw-normal'>
                            {i18n.t(`smart_order.description`)}
                          </label>
                        </div>
                        <EditorQuill
                          change={(value: string) => {
                            setCanAlert(true)
                            setDescription(value)
                          }}
                          value={description}                         
                        />

                        <div className={styles.descriptionFooter}>
                          <div>
                            {pluginIA && pluginIA !== '' && (
                              <div
                                className='d-flex justify-content-start'
                                style={{maxWidth: '100%'}}
                              >
                                {loadingDescIA ? (
                                  <ReactLoading
                                    type='spin'
                                    color='#D5D5D5'
                                    height={25}
                                    width={25}
                                  />
                                ) : (
                                  <Button
                                    text={`${i18n.t(`buttons.generate_ia`)} descrição`}
                                    color='info'
                                    size='small'
                                    horizontalPadding={5}
                                    btnAttr={{
                                      type: 'button',
                                    }}
                                    svgIcon={
                                      <svg
                                        width='15'
                                        height='15'
                                        viewBox='0 0 15 15'
                                        fill='none'
                                        xmlns='http://www.w3.org/2000/svg'
                                      >
                                        <path
                                          d='M6.39844 1.92578L6.78125 0.886719C6.80859 0.804688 6.89062 0.75 7 0.75C7.08203 0.75 7.16406 0.804688 7.19141 0.886719L7.57422 1.92578L8.61328 2.30859C8.69531 2.33594 8.75 2.41797 8.75 2.5C8.75 2.60938 8.69531 2.69141 8.61328 2.71875L7.57422 3.10156L7.19141 4.11328C7.16406 4.19531 7.08203 4.25 7 4.25C6.89062 4.25 6.80859 4.19531 6.78125 4.11328L6.39844 3.10156L5.38672 2.71875C5.30469 2.69141 5.25 2.60938 5.25 2.5C5.25 2.41797 5.30469 2.33594 5.38672 2.30859L6.39844 1.92578ZM12.6055 2.0625L9.59766 5.07031L10.5547 6.02734L13.5625 3.01953L12.6055 2.0625ZM2.1875 12.5078L3.11719 13.4375L9.625 6.95703L8.66797 6L2.1875 12.5078ZM11.6758 1.16016C12.1953 0.640625 13.0156 0.640625 13.5352 1.16016L14.4648 2.08984C14.9844 2.60938 14.9844 3.42969 14.4648 3.94922L4.04688 14.3672C3.52734 14.8867 2.70703 14.8867 2.1875 14.3672L1.25781 13.4375C0.738281 12.918 0.738281 12.0977 1.25781 11.5781L11.6758 1.16016ZM0.191406 3.97656L1.75 3.375L2.32422 1.84375C2.35156 1.70703 2.48828 1.625 2.625 1.625C2.73438 1.625 2.87109 1.70703 2.89844 1.84375L3.5 3.375L5.03125 3.97656C5.16797 4.00391 5.25 4.14062 5.25 4.25C5.25 4.38672 5.16797 4.52344 5.03125 4.55078L3.5 5.125L2.89844 6.68359C2.87109 6.79297 2.73438 6.875 2.625 6.875C2.48828 6.875 2.35156 6.79297 2.32422 6.68359L1.75 5.125L0.191406 4.55078C0.0820312 4.52344 0 4.38672 0 4.25C0 4.14062 0.0820312 4.00391 0.191406 3.97656ZM9.81641 10.9766L11.375 10.375L11.9492 8.84375C11.9766 8.70703 12.1133 8.625 12.25 8.625C12.3594 8.625 12.4961 8.70703 12.5234 8.84375L13.125 10.375L14.6562 10.9766C14.793 11.0039 14.875 11.1406 14.875 11.25C14.875 11.3867 14.793 11.5234 14.6562 11.5508L13.125 12.125L12.5234 13.6836C12.4961 13.793 12.3594 13.875 12.25 13.875C12.1133 13.875 11.9766 13.793 11.9492 13.6836L11.375 12.125L9.81641 11.5508C9.70703 11.5234 9.625 11.3867 9.625 11.25C9.625 11.1406 9.70703 11.0039 9.81641 10.9766Z'
                                          fill='white'
                                        />
                                      </svg>
                                    }
                                    click={generateDescriptionIA}
                                    btnClass='fw-bolder me-3 d-flex flex-row gap-2 align-items-center'
                                    txtClass='text-nowrap'
                                  />
                                )}
                              </div>
                            )}
                          </div>

                          <small>
                            {description.length} {i18n.t(`smart_order.from`)} 415{' '}
                            {i18n.t(`smart_order.characters`)}
                          </small>
                        </div>

                        <div className='mt-6'>
                          <div>
                            <label className='form-label fw-normal'>
                              {i18n.t(`smart_order.technical_specification`)}
                            </label>
                          </div>
                        <EditorQuill
                          change={(value: string) => {
                              setCanAlert(true)
                              setTechnicalSpecification(value)
                            }}
                            value={technicalSpecification}
                           
                          />

                          <p className='mt-2 text-end'>
                            <small>
                              {technicalSpecification.length} {i18n.t(`smart_order.from`)} 415{' '}
                              {i18n.t(`smart_order.characters`)}
                            </small>
                          </p>

                          <Input
                            inputAttr={{
                              type: 'select',
                            }}
                            search
                            label={i18n.t(`smart_order.category`)}
                            options={categories}
                            value={subcategoryId}
                            change={(value: string) => {
                              setCanAlert(true)
                              setSubcategoryId(value)
                            }}
                            marginTop='mt-0'
                          />
                        </div>
                      </div>

                      <div className='row g-6'>
                        <div className='col-md-6'>
                          <Input
                            inputAttr={{
                              type: 'select',
                            }}
                            label={i18n.t(`smart_order.mark`)}
                            options={marks}
                            value={markId}
                            change={(value: string) => {
                              setCanAlert(true)
                              setMarkId(value)
                            }}
                          />
                        </div>
                        <div className='col-md-6'>
                          <Input
                            inputAttr={{
                              type: 'select',
                            }}
                            label={i18n.t(`smart_order.measurement_unit`)}
                            options={measurements}
                            value={measurementId}
                            change={(value: string) => {
                              setCanAlert(true)
                              setMeasurementId(value)
                            }}
                          />
                        </div>
                      </div>

                      <div className='row g-6'>
                        <div className='col-md-6'>
                          <Input
                            inputAttr={{
                              type: 'select',
                            }}
                            label='Status'
                            options={[
                              {select: i18n.t(`general.active`), value: true},
                              {select: i18n.t(`general.inactive`), value: false},
                            ]}
                            value={status}
                            change={(value: boolean) => {
                              setCanAlert(true)
                              setStatus(value)
                            }}
                          />
                        </div>
                        <div className='col-md-6'>
                          <Input
                            inputAttr={{
                              type: 'default',
                            }}
                            placeholder='0'
                            label={i18n.t(`smart_order.order`)}
                            smalltext='(para exibição no webapp)'
                            value={order}
                            change={(value: string) => {
                              setCanAlert(true)
                              setOrder(value)
                            }}
                          />
                        </div>
                      </div>

                      <div className='mt-6'>
                        <Input
                          inputAttr={{type: 'image-upload'}}
                          label='Guia de Medidas'
                          change={(newFiles: File[]) => {
                            setCanAlert(true)
                            setFilesMedidas(newFiles)
                          }}
                          iconImage={'bi bi-card-image'}
                          sizeImage={'As Imagens devem ter 200x200px para melhor visualização.'}
                          verticalAlign={true}
                          maxFiles={1}
                        />
                      </div>

                      {/* Preços */}
                      <div className={`${styles.groupTitle} mt-2`}>Preços</div>
                      <div className='mt-2 row g-6'>
                        <div className='mt-0 col-md-4'>
                          <Input
                            inputAttr={{
                              type: 'money',
                            }}
                            currency='BRL'
                            locale='pt-BR'
                            label={i18n.t(`smart_order.cost_price`)}
                            change={(value: number) => {
                              setCanAlert(true)
                              setCostPrice(value)
                            }}
                            value={costPrice}
                            marginTop='mt-0'
                          />
                        </div>
                        <div className='mt-0 col-md-4'>
                          <Input
                            inputAttr={{
                              type: 'money',
                            }}
                            currency='BRL'
                            locale='pt-BR'
                            label={i18n.t(`smart_order.sell_price`)}
                            change={(value: number) => {
                              setCanAlert(true)
                              setPrice(value)
                            }}
                            value={price}
                            marginTop='mt-0'
                          />
                        </div>
                        <div className='mt-0 col-md-4'>
                          <Input
                            inputAttr={{
                              type: 'money',
                            }}
                            currency='BRL'
                            locale='pt-BR'
                            label={i18n.t(`smart_order.promotional_price`)}
                            change={(value: number) => {
                              setCanAlert(true)
                              setPromotionalPrice(value)
                            }}
                            value={promotionalPrice}
                            marginTop='mt-0'
                          />
                        </div>
                      </div>

                      {/* Estoque */}
                      <div className={`${styles.groupTitle} mt-6`}>Estoque</div>
                      <div>
                        <div className={`${styles.containerStock}`}>
                          <div className={`d-flex flex-column`}>
                            <div
                              className={`cursor-pointer ${styles.radioItem}`}
                              onClick={() => {
                                setCanAlert(true)
                                setStockType('infinite')
                              }}
                            >
                              <span className={styles.radioLabel}>Infinito</span>
                              <div
                                className={`${styles.radioCircle} ${
                                  stockType === 'infinite' ? styles.checked : ''
                                }`}
                              >
                                {stockType === 'infinite' && (
                                  <i className={`bi bi-check ${styles.checkIcon}`}></i>
                                )}
                              </div>
                            </div>
                            <div
                              className={`cursor-pointer ${styles.radioItem}`}
                              onClick={() => {
                                setCanAlert(true)
                                setStockType('limited')
                              }}
                            >
                              <span className={styles.radioLabel}>Limitado</span>
                              <div
                                className={`${styles.radioCircle} ${
                                  stockType === 'limited' ? styles.checked : ''
                                }`}
                              >
                                {stockType === 'limited' && (
                                  <i className={`bi bi-check ${styles.checkIcon}`}></i>
                                )}
                              </div>
                            </div>
                          </div>

                          <div
                            className={`${styles.stockLine} ${
                              stockType === 'limited' ? styles.visible : ''
                            }`}
                          >
                            <Input
                              inputAttr={{
                                type: 'number',
                              }}
                              label='Quantidade'
                              value={stockQuantity}
                              change={(value: number) => {
                                setCanAlert(true)
                                setStockQuantity(value)
                              }}
                              placeholder='0'
                              marginTop='mt-0'
                            />

                            <div
                              className={`${styles.stockAlert} ${
                                stockType === 'limited' ? styles.visible : ''
                              }`}
                            >
                              <i className='bi bi-exclamation-triangle-fill'></i>
                              <span>Estoque somente para produtos com variação</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Volumetria */}
                      <div className={`${styles.groupTitle} mt-6`}>Volumetria</div>

                      <div className='mt-2 row g-6'>
                        <div className='mt-0 col-md-6'>
                          <Input
                            inputAttr={{
                              type: 'number',
                            }}
                            placeholder='0'
                            label={i18n.t(`smart_order.weight`)}
                            change={(value: number) => {
                              setCanAlert(true)
                              setWeight(value)
                            }}
                            value={weight}
                            marginTop='mt-0'
                          />
                        </div>
                        <div className='mt-0 col-md-6'>
                          <Input
                            inputAttr={{
                              type: 'number',
                            }}
                            placeholder='0'
                            label={i18n.t(`smart_order.height`)}
                            change={(value: number) => {
                              setCanAlert(true)
                              setHeight(value)
                            }}
                            value={height}
                            marginTop='mt-0'
                          />
                        </div>
                        <div className='mt-0 col-md-6'>
                          <Input
                            inputAttr={{
                              type: 'number',
                            }}
                            placeholder='0'
                            label={i18n.t(`smart_order.width`)}
                            change={(value: number) => {
                              setCanAlert(true)
                              setWidth(value)
                            }}
                            value={width}
                            marginTop='mt-4'
                          />
                        </div>
                        <div className='mt-0 col-md-6'>
                          <Input
                            inputAttr={{
                              type: 'number',
                            }}
                            placeholder='0'
                            label={i18n.t(`smart_order.depth`)}
                            change={(value: number) => {
                              setCanAlert(true)
                              setDeep(value)
                            }}
                            value={deep}
                            marginTop='mt-4'
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='card mt-8'>
              <div className='px-10 py-5'>
                <h1 className={styles.sectionTitle}>
                  <i className='bi bi-images'></i>
                  Imagem Produto
                </h1>
                <div className='mt-8'>
                  <Input
                    inputAttr={{type: 'image-upload'}}
                    label='Imagens Produto'
                    change={(newFiles: File[]) => {
                      setCanAlert(true)
                      setFilesProduto(newFiles)
                    }}
                    iconImage={'bi bi-images'}
                    mainTextImage={'Arraste e solte sua imagem principal e imagens adicionais'}
                    descriptionImage={
                      'Você pode arrastar e soltar as imagens para organizá-las. A imagem que ficar na primeira posição será considerada como a imagem principal.'
                    }
                    sizeImage={'As Imagens devem ter 200x200px para melhor visualização.'}
                    dragAndDropImage={true}
                  />
                </div>
              </div>
            </div>
            <div className='card mt-8'>
              <div className='px-10 py-5'>
                <h1 className={styles.sectionTitle}>
                  <i className='bi bi-grid-3x3-gap'></i>
                  Variação Produto
                </h1>
                <div className='mt-8'>
                  <div className='d-flex gap-4'>
                    <div className='d-flex align-items-center gap-3'>
                      <div
                        className={`${styles.checkboxContainer} ${
                          isSimpleProduct ? styles.checked : ''
                        }`}
                        onClick={() => {
                          setCanAlert(true)
                          if (isVariationProduct) setIsVariationProduct(false)
                          setIsSimpleProduct(true)
                        }}
                      >
                        <input
                          type='checkbox'
                          checked={isSimpleProduct}
                          className={styles.checkboxInput}
                        />
                        <span className={styles.checkboxLabel}>Produto Simples</span>
                      </div>
                    </div>

                    <div className='d-flex align-items-center gap-3'>
                      <div
                        className={`${styles.checkboxContainer} ${
                          isVariationProduct ? styles.checked : ''
                        }`}
                        onClick={() => {
                          setCanAlert(true)
                          if (isSimpleProduct) setIsSimpleProduct(false)
                          setIsVariationProduct(true)
                        }}
                      >
                        <input
                          type='checkbox'
                          checked={isVariationProduct}
                          className={styles.checkboxInput}
                        />
                        <span className={styles.checkboxLabel}>Produto com Variação</span>
                      </div>
                    </div>
                  </div>
                  {!isVariationProduct ? (
                    <div className='mt-8'>
                      <p className='mt-8'>Tipo: {isSimpleProduct ? 'Simples' : 'Com Variação'}</p>
                    </div>
                  ) : (
                    <>
                      <div className={`${styles.groupTitle} mt-6`}>Variações</div>

                      {gradeSelected.length <= 0 && (
                        <div
                          className='d-flex align-items-center gap-2'
                          onClick={() => {
                            setShowVariacoesModal(true)
                          }}
                          style={{cursor: 'pointer'}}
                        >
                          <div className={styles.addButtonCircle}>
                            <i className='fas fa-plus'></i>
                          </div>
                          <h2 className='m-0 fs-5' style={{color: '#009ef7'}}>
                            Adicionar Variações
                          </h2>
                        </div>
                      )}
                      <div className='mt-2'>
                        {gradeSelected.map((grade) => (
                          <div key={grade.variationId} className='mb-3'>
                            <div className='fw-bold mb-2'>{findNameGrade(grade)}</div>
                            <div className='d-flex flex-wrap gap-2'>
                              {grade.variations.map((variation) => (
                                <span key={variation} className={styles.variationChip}>
                                  {variation}
                                  <button
                                    type='button'
                                    className={styles.variationRemove}
                                    onClick={() =>
                                      handleRemoveVariation(grade.variationId, variation)
                                    }
                                  >
                                    <i className={`bi bi-x ${styles.variationRemoveIcon}`}></i>
                                  </button>
                                </span>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>
                      {variacoesTabela.length > 0 && (
                        <>
                          <table className={`${styles.variationTable}`}>
                            <thead>
                              <tr>
                                <th>Variação</th>
                                <th>Estoque</th>
                                <th>Preço</th>
                                <th>Status</th>
                                <th>Ação</th>
                              </tr>
                            </thead>
                            <tbody>
                              {variacoesTabela.map((item) => (
                                <tr key={item.id}>
                                  <td>
                                    <span className={styles.variationName}>
                                      <img
                                        src={
                                          item.img
                                            ? typeof item.img === 'string'
                                              ? item.img
                                              : item.img instanceof File
                                              ? URL.createObjectURL(item.img)
                                              : 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/icons/card-image.svg'
                                            : 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/icons/card-image.svg'
                                        }
                                        alt={item.nome}
                                        className={styles.variationImg}
                                        onClick={() => {
                                          setVariacaoSelecionada(item)
                                          setShowEditVariacao(true)
                                        }}
                                        style={{cursor: 'pointer'}}
                                      />
                                      {item.nome}
                                    </span>
                                  </td>
                                  <td>
                                    <div style={{width: 60}}>
                                      <input
                                        type='text'
                                        value={item.estoque}
                                        className={styles.variationInput}
                                        onChange={(e) => {
                                          setVariacoesTabela((prev) =>
                                            prev.map((v) =>
                                              v.id === item.id ? {...v, estoque: e.target.value} : v
                                            )
                                          )
                                        }}
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <div style={{width: 100}}>
                                      <input
                                        type='text'
                                        value={item.precoVenda}
                                        className={styles.variationInput}
                                        onChange={(e) => {
                                          setVariacoesTabela((prev) =>
                                            prev.map((v) =>
                                              v.id === item.id
                                                ? {...v, precoVenda: e.target.value}
                                                : v
                                            )
                                          )
                                        }}
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <label className={styles.switch}>
                                      <input
                                        type='checkbox'
                                        checked={item.status}
                                        onChange={(e) => {
                                          setVariacoesTabela((prev) =>
                                            prev.map((v) =>
                                              v.id === item.id
                                                ? {...v, status: e.target.checked}
                                                : v
                                            )
                                          )
                                        }}
                                      />
                                      <span className={styles.slider}></span>
                                    </label>
                                  </td>
                                  <td>
                                    <button
                                      onClick={() => {
                                        setVariacaoSelecionada(item)
                                        setShowEditVariacao(true)
                                      }}
                                      className={styles.actionBtn}
                                      title='Editar Variação'
                                      style={{cursor: 'pointer'}}
                                    >
                                      <i className='fas fa-pen'></i>
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <div
                            className={`mt-2 ${styles.editGradesButton}`}
                            onClick={() => {
                              setShowVariacoesModal(true)
                            }}
                          >
                            <i className='fas fa-pen'></i>
                            <span>Editar Grades</span>
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>

          {showVariacoesModal && (
            <IndexGrade
              onCloseAction={() => {
                setShowVariacoesModal(false)
              }}
              title='Grades'
              grids={grids}
              gradeSelected={gradeSelected}
              setGradeSelected={setGradeSelected}
            />
          )}
          {showEditVariacao && (
            <EditVariacao
              onCloseAction={() => {
                setShowEditVariacao(false)
                setVariacaoSelecionada(null)
              }}
              title='Editar Variação'
              item={variacaoSelecionada}
              onSave={handleSaveVariacao}
            />
          )}
        </>
      )}
    </>
  )
}

const NewCriarProdutos: FC = () => {
  const {loginInfo} = useAuth()
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {
            title: i18n.t(`smart_order.product`),
            path: loginInfo.plugintype === 'varejo' ? 'product_varejo' : 'product_fashion',
            isActive: true,
          },
          {
            title: i18n.t(`buttons.create`),
            path:
              loginInfo.plugintype === 'varejo' ? 'product_varejo/criar' : 'product_fashion/criar',
            isActive: true,
          },
        ]}
      >
        {`${i18n.t(`buttons.create`)} ${i18n.t(`smart_order.product`)}`}
      </PageTitle>
      <NewCriarProdutosContent />
    </>
  )
}

export {NewCriarProdutos}
